import { useUserProfileStore } from 'app/railways/domains/profile/features/user-profile-data';

import { TRoleNames } from './roles';

export const useUserRoles = () => {
  const userProfileStore = useUserProfileStore();
  const roles = userProfileStore.data.roles;
  const userRoles = roles.map((r) => r.name as TRoleNames);

  return userRoles;
};
